// ─────────────────────────────────────────────────────────────────────────────
// AWS Amplify Configuration
//
// Values are injected at build time via REACT_APP_* environment variables.
// The deploy script (or CI pipeline) sets these from CDK stack outputs.
//
// For local development, create a .env.local file:
//   REACT_APP_USER_POOL_ID=us-east-1_wPlkzMUX6
//   REACT_APP_USER_POOL_CLIENT_ID=2o5sntrdj13h1scg86htqdec4e
//   REACT_APP_AWS_REGION=us-east-1
// ─────────────────────────────────────────────────────────────────────────────

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      loginWith: {
        email: true
      }
    }
  }
};

export default awsconfig;
